import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  Grid,
  Paper,
  TextField,
  Typography,
  Autocomplete,
  Toolbar,
  Chip,
  Divider,
  FormControlLabel,
  Checkbox,
  Modal,
  Box,
  List,
  ListItemText,
  Button,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ListItem } from "@mui/material";

import { BASE_URL } from "../../global";
import CButton from "../../utils/commonComponent/Custom/Button";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import EditWrap from "../../utils/commonComponent/editWrap";

export default function Template(props) {
  const navigate = useNavigate();
  const [templateConfig, setTemplateConfig] = useState([]);

  const [materialScopeArray, setMaterialScopeArray] = useState([]);
  const [materialTestingsArray, setMaterialTestingsArray] = useState([]);
  const [materialId, setMaterialId] = useState(null);
  const [testId, setTestId] = useState(null);
  const [materialName, setMaterialName] = useState(null);
  const [tables, setTables] = useState([]);
  const [editAccess, setEditAccess] = React.useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );

  // destructuring rgba from state
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const params = useParams();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const onSubmit = () => {
    let jsonData = {
      materialId: materialId,
      testId: testId,
      config: JSON.stringify(templateConfig),
    };
    let url = BASE_URL;
    if (params.id > 0) {
      axiosWithToken
        .patch(url + `datasheetTemplate/${params.id}`, jsonData)
        .then((res) => {
          toast.success("Template updated successfully");
          setTimeout(refresh, 500);
        })
        .catch((error) => {
          console.log(error);
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong error code: 1 !");
          }
        });
    } else {
      axiosWithToken
        .post(url + "datasheetTemplate", jsonData)
        .then((res) => {
          toast.success("Template created successfully");
          setTimeout(() => navigate("/master/datasheetTemplate"), 1000);
        })
        .catch((error) => {
          console.log(error);
          if (error.message !== "request_aborted") {
            toast.error("Something Went Wrong error code: 2 !");
          }
        });
    }
  };

  const addStep = () => {
    setTemplateConfig([
      ...templateConfig,
      { instructions: [""], outputStream: "" },
    ]);
  };
  const addInstruction = (stepIndex) => {
    let _templateConfig = templateConfig;
    _templateConfig[stepIndex]["instructions"].push("");
    setTemplateConfig([..._templateConfig]);
  };

  const updateInstructionValue = (stepIndex, instructionIndex, value) => {
    let _templateConfig = templateConfig;
    _templateConfig[stepIndex]["instructions"][instructionIndex] = value;
    setTemplateConfig([..._templateConfig]);
  };

  const updateOoutputStreamValue = (stepIndex, value) => {
    let _templateConfig = templateConfig;
    _templateConfig[stepIndex]["outputStream"] = value;
    setTemplateConfig([..._templateConfig]);
  };

  const getDatasheetTemplate = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + `datasheetTemplate?_where=(id,eq,${params.id})`)
      .then((res) => {
        if (res.data.length > 0) {
          setTemplateConfig(
            res.data[0]?.config ? JSON.parse(res.data[0]?.config) : []
          );
          setMaterialId(Number(res.data[0].materialId));
          setTestId(Number(res.data[0].testId));
        }
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong error code: 4 !");
        }
        console.log(error);
      });
  };

  const getMaterialScopeList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "materialScope?_where=(status,eq,1)")
      .then((res) => {
        setMaterialScopeArray(res.data);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something Went Wrong error code: 5 !");
        }
      });
  };

  const getMaterialTestingsList = async () => {
    try {
      const sqlQuery = {
        query: `SELECT id, testName, materialId FROM materialTestings WHERE status = 1 AND materialId = ${materialId}`,
      };
      const res = await axiosWithToken.post(`${BASE_URL}dynamic`, sqlQuery);
      setMaterialTestingsArray(res.data || []);
    } catch (error) {
      if (error.message !== "request_aborted") {
        toast.error("Something went wrong! Error code: 5");
      }
    }
  };

  useEffect(() => {
    getMaterialScopeList();
    if (params.id) getDatasheetTemplate();
  }, []);

  useEffect(() => {
    if (materialId) getMaterialTestingsList();
  }, [materialId]);

  useEffect(() => {
    if (materialScopeArray !== null && materialId !== null) {
      for (let i = 0; i < materialScopeArray.length; i++) {
        if (materialScopeArray[i].id == materialId) {
          setMaterialName(materialScopeArray[i].MaterialName);
          break;
        }
      }
    }
  }, [materialScopeArray, materialId]);

  const renderHelpModal = () => {
    return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Formula Help
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            same as mathematical expression with following variations
            <hr />
            <ul>
              <li>
                1. multiplication: <code>*</code>
              </li>
              <li>
                2. for power:{" "}
                <code>pow(&lt;base value&gt;, &lt;exponent&gt;)</code>
              </li>
              <li>
                3. for square root : <code>sqrt(&lt;value&gt;)</code>, value:
                either number of column code (eg. c1)
              </li>
            </ul>
          </Typography>
        </Box>
      </Modal>
    );
  };

  return (
    <EditWrap>
      <Typography variant="h6" component="h6" sx={{ mb: 2, textAlign: "left" }}>
        {params.id > 0 ? "Update" : "Create new"} datasheet template
      </Typography>
      <div className="flex flex-wrap gap-4 mb-6">
        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/3">
          <Autocomplete
            size="small"
            id="combo-box-demo"
            value={materialId + ", " + materialName}
            options={materialScopeArray.map((instrument) => {
              return {
                label: instrument.id + ", " + instrument.MaterialName,
              };
            })}
            onChange={(event, value) => {
              if (value) {
                setMaterialId(parseInt(value.label.split(",")[0]));
                setMaterialName(value.label.split(",")[1]);
                // fetchUncertaintyFactors(value.label.split(",")[0]);
              }
            }}
            renderInput={(params) => (
              <TextField {...params} label="Material" className="w-full" />
            )}
          />
        </div>

        <div className="w-full sm:w-1/2 md:w-1/3 lg:w-1/3">
          <Autocomplete
            id="testings"
            size="small"
            options={materialTestingsArray}
            value={
              materialTestingsArray.find((opt) => opt.id == testId) || null
            }
            getOptionLabel={(option) => option?.testName || ""}
            onChange={(_, value) => setTestId(value ? value.id : null)}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField {...params} label="Testings" className="w-full" />
            )}
          />
        </div>
      </div>

      {/* datasheet table confiurations */}
      <div>
        <Divider sx={{ mt: 5 }}>
          <Chip
            label="Datasheet table configuration"
            variant="outlined"
            sx={{ fontSize: "16px" }}
          />
        </Divider>
      </div>
      <div sx={{ mb: 3 }}>
        <Typography variant="h6" component="h6">
          1. add steps
          <CButton
            variant="contained"
            size="small"
            label={<AddIcon />}
            sx={{ ml: 3 }}
            onClick={() => {
              addStep();
            }}
          ></CButton>
        </Typography>
      </div>
      <br />
      <div className="flex flex-col gap-2">
        {(templateConfig || []).map((step, stepIndex) => (
          <div key={stepIndex} className="w-full">
            <List
              dense
              sx={{
                borderRadius: 1,
                border: 1,
                borderColor: "grey.600",
                "&:hover": { borderColor: "grey.200" },
              }}
            >
              <ListItem className="flex justify-between items-center">
                <ListItemText primary={`Step #${stepIndex + 1}`} />
                <CButton
                  variant="contained"
                  size="small"
                  label={
                    <span className="flex items-center gap-1">
                      instructions <AddIcon />
                    </span>
                  }
                  onClick={() => addInstruction(stepIndex)}
                />
              </ListItem>

              <div className="flex flex-col gap-2 p-2">
                {step.instructions.map((instruction, instructionIndex) => (
                  <div key={instructionIndex} className="w-11/12">
                    <TextField
                      id="outlined-basic"
                      label="Add instruction"
                      size="small"
                      fullWidth
                      inputProps={{ autoComplete: "off" }}
                      variant="outlined"
                      value={instruction}
                      onChange={(e) =>
                        updateInstructionValue(
                          stepIndex,
                          instructionIndex,
                          e.target.value
                        )
                      }
                    />
                  </div>
                ))}

                <div className="w-11/12 mt-4">
                  <span className="block mb-2  text-center">
                    Output stream:
                  </span>

                  <div className="flex flex-col gap-2">
                    <FormControlLabel
                      classes={{ alignItems: "left" }}
                      style={{ display: "flex" }}
                      control={
                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              updateOoutputStreamValue(stepIndex, "pass");
                            }
                          }}
                        />
                      }
                      label="pass to next step"
                      checked={step.outputStream === "pass" ? true : false}
                    />

                    <TextField
                      id="outlined-basic"
                      label="Add destination mapping"
                      size="small"
                      fullWidth
                      inputProps={{ autoComplete: "off" }}
                      variant="outlined"
                      value={step.outputStream}
                      onInput={(e) =>
                        updateOoutputStreamValue(stepIndex, e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
            </List>
          </div>
        ))}
      </div>

      <Toolbar
        style={{
          padding: "0px",
          overflow: "auto",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
        }}
      >
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        >
          Cancel
        </Button>
        <CButton
          variant="contained"
          label="SAVE"
          disabled={!(editAccess?.includes(1) || editAccess?.includes(0))}
          onClick={() => {
            if (!materialId) {
              toast.error("Please select a instrument");
              return;
            }
            // props.setLoader(true);
            onSubmit();
          }}
        >
          SAVE
        </CButton>
      </Toolbar>
      <ToastContainer />
      {renderHelpModal()}
    </EditWrap>
  );
}
